'use client';

import { useState, useEffect } from 'react';

type Result = {
  rating: number;
  name: string;
  loading: boolean;
};

const initialResult: Result = {
  rating: 0,
  name: '',
  loading: true,
};

export function useRatingReviews(placeId?: string) {
  const [result, setResult] = useState<Result>(initialResult);

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      setResult((prev) => ({ ...prev, loading: true }));

      try {
        const url = placeId
          ? `/api/google-rating-reviews?placeId=${encodeURIComponent(placeId)}`
          : `/api/google-rating-reviews`;
        const request = await fetch(url, {
          signal: controller.signal,
        });

        if (request.ok && !controller.signal.aborted) {
          const response = await request.json();

          setResult({
            rating: response?.rating || 0,
            name: response?.name || '',
            loading: false,
          });
        }
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') {
          return;
        }

        if (!controller.signal.aborted) {
          setResult((prev) => ({ ...prev, loading: false }));
        }
      }
    };

    fetchData();

    return () => {
      controller.abort();
    };
  }, [placeId]);

  return result;
}
